<template>
  <div>
    <el-dialog title="VNPT Smart CA" :visible.sync="isOpen" width="30%" :before-close="handleClose">
      <template #title>
        <div>
          <img width="35" height="35" src="@/assets/images/vnptca.svg" alt="">
          <span class="text-lg font-semibold ml-2" style="color: rgb(2 113 177);">
            VNPT Smart CA
          </span>
        </div>
      </template>
      <!-- Content -->

      <div class="content" v-loading="!selectedCredential && loading" element-loading-text="Đang xử lý dữ liệu..."
        element-loading-spinner="el-icon-loading">
        <!-- List Credential Smart CA -->
        <div v-if="isSelectCredential" class="list-credential">
          <el-radio-group class="flex gap-1" v-model="indexSelectedCredential" size="large">
            <el-radio class="flex w-100 h-100 mr-0 py-2" v-for="(item, index) in credentials" :key="index"
              :label="index" border>
              <div class="flex items-center justify-between">
                <div>
                  <p class="mb-1">{{ item.service_type }}</p>
                  <small>{{ certValidFrom(item.cert_valid_from) }} - {{ certValidTo(item.cert_valid_to) }}</small>
                </div>
                <div>
                  <!-- {{ item.service_type }} -->
                </div>
              </div>
            </el-radio>
          </el-radio-group>
        </div>
        <!-- Info Credentials -->
        <div class="info-credential" v-if="!isSelectCredential && selectedCredential">
          <div class="flex items-center justify-between">
            <h3>Chứng thư số</h3>
            <el-button v-if="credentials.length > 1" class="fs-12" size="small" type="primary"
              style="background-color: rgb(2 113 177);" @click="isSelectCredential = true">Thay đổi chứng
              thư</el-button>
          </div>
          <div class="flex items-center gap-3 mt-3">
            <div>
              <p class="mb-2">Loại dịch vụ:</p>
              <p class="mb-2">Chủ thể:</p>
              <p class="mb-2">MST/CCCD:</p>
              <p class="mb-2">Tổ chức chứng thực:</p>
              <p class="mb-2">Thời hạn sử dụng:</p>
              <p class="mb-2">Trạng thái:</p>
            </div>
            <div class="">
              <p class="mb-2">{{ selectedCredential.service_type }}</p>
              <p class="mb-2">{{ distinguishedName.cn || 'N/A' }}</p>
              <p class="mb-2">{{ distinguishedName.uid || 'N/A' }}</p>
              <p class="mb-2">VNPT Smart CA</p>
              <p class="mb-2">{{ certValidFrom() || 'N/A' }} - {{ certValidTo() || 'N/A' }}</p>
              <div class="mb-2">
                <span v-if="selectedCredential.cert_status_code === 'VALID'">🟢</span>
                <span v-else>🔴</span>
                <span class="ml-1">{{ selectedCredential.cert_status || 'N/A' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="fs-16" size="small" plain type="primary" @click="isOpen = false">{{ $t("Đóng")
        }}</el-button>
        <el-button v-if="isSelectCredential" class="fs-16" size="small" type="primary" @click="btnSelectCredential">
          {{ $t("Chọn") }}
        </el-button>
        <el-button v-else class="fs-16" size="small" type="primary" @click="requestSign">
          {{ $t("Ký") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SignatureRequest from '@/api/request/SignatureRequest'

export default {
  name: 'ModalVnptCA',
  data () {
    return {
      isOpen: false,
      loading: false,
      credentials: [],
      indexSelectedCredential: 0,
      selectedCredential: null,
      isSelectCredential: false,
      distinguishedName: {
        uid: '', // CCCD / MST
        cn: '', // Common Name
        l: '', // Locality Name
        o: '', // Organization Name
        st: '', // State or Province Name
        c: '' // Country Name
      }
    }
  },
  methods: {
    async handleOpen () {
      this.isOpen = true
      this.isSelectCredential = false
      await this.getCredentials()
    },
    handleClose () {
      this.isOpen = false
    },
    btnSelectCredential () {
      this.isSelectCredential = false
      this.selectedCredential = this.credentials[this.indexSelectedCredential]

      // Extracting distinguished name information
      this.certInfo()
    },
    async requestSign () {
      this.$emit('onRequestSign', this.selectedCredential)
      this.handleClose()
    },
    async getCredentials () {
      this.loading = true
      const request = new SignatureRequest()

      var body = {
        cccd: this.$user.doctor.national_id
      }
      await request.getVnptCredentials(body).then(response => {
        if (response.data && response.data.data.user_certificates.length > 0) {
          this.credentials = response.data.data.user_certificates
          this.selectedCredential = this.credentials[0]
          // Extracting distinguished name information
          this.certInfo()
        } else {
          this.credentials = []
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.loading = false
      })
    },
    certInfo () {
      const parts = this.selectedCredential.cert_subject.split(',')
      const result = {}
      parts.forEach(part => {
        const [key, value] = part.split('=')
        if (key && value) {
          result[key.toLowerCase()] = value
        }
      })

      this.distinguishedName = result
    },
    certValidFrom (cert_valid_from) {
      if (cert_valid_from) {
        return window.moment(cert_valid_from).format('DD/MM/YYYY')
      }
      return window.moment(this.selectedCredential.cert_valid_from).format('DD/MM/YYYY')
    },
    certValidTo (cert_valid_to) {
      if (cert_valid_to) {
        return window.moment(cert_valid_to).format('DD/MM/YYYY')
      }
      return window.moment(this.selectedCredential.cert_valid_to).format('DD/MM/YYYY')
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
  }
}
</style>